export interface SupplierItem {
  id: number;
  number: number;
  subNumber: number;
  name: string;
}
